<template lang="pug">
  .component-invoice-list-filter-form.filter-form
    .row
      .columns.large-3
        SearchEntity(entity="clients", v-model="search.client_id")
      .columns.large-2
        selectize-plan(@optionSelected="selectPlan")
      .columns.large-2
        date-picker(:placeholder="'Expire from'", v-model="search.expire_from")
      .columns.large-2
        date-picker(:placeholder="'Expire to'", v-model="search.expire_to")
      .columns.large-2
        select(v-model="search.active")
          option(value="") All
          option(value="1") Not Expired
          option(value="0") Expired
      .columns
        a.fa.fa-angle-double-down.fa-2x(v-on:click="filterSubscriptions")
</template>
<script type="text/babel">
  import KeplerBackofficeSdk from "src/lib/kepler/backoffice"
  import DatePicker from "components/structure/DatePicker"
  import SelectizeClient from "../lists/selectize/SelectizeClient";
  import SelectizePlan from "../lists/selectize/SelectizePlan";
  import SearchEntity from "../SearchEntity.vue";

  export default {
    name: "SubscriptionListForm",
    components: {
      SearchEntity,
      SelectizePlan,
      SelectizeClient,
      KeplerBackofficeSdk,
      DatePicker
    },
    data() {
      return {
        search: {
          client_id: null,
          plan_id: null,
          expire_from: null,
          expire_to: null,
          status: null,
          active: null
        }
      }
    },
    mounted() {

    },
    methods: {
      selectClient(client) {
        this.search.client_id = client.id
      },
      selectPlan(plan) {
        this.search.plan_id = plan.id
      },
      filterSubscriptions() {
        this.$cleanObject(this.search)
        this.$emit("filterSubscriptions", this.search)
      }
    },
    computed: {}
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// SubscriptionListForm.vue?478644fc